import { createSlice } from '@reduxjs/toolkit';
import EFunction from '../../utils/FunctionPage';

const initialState = {
    funcId: EFunction.login,
 };

export const switchFuncSlice = createSlice({
    name: 'switchFunc',
    initialState,
    reducers: {
        setFunc(state, action) {
            state.funcId = action.payload;
        },
    }
});

export default switchFuncSlice;